var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRosterSport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 22.3958C17.9656 22.3958 22.3962 17.9653 22.3962 12.5C22.3962 7.03469 17.9656 2.60417 12.5003 2.60417C7.03501 2.60417 2.60449 7.03469 2.60449 12.5C2.60449 17.9653 7.03501 22.3958 12.5003 22.3958Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37109 6.99167C6.62053 6.68718 6.93334 6.44073 7.28774 6.26947C7.64214 6.0982 8.02961 6.00625 8.42318 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05078 8.73125C7.34501 8.47024 7.69213 8.27584 8.0684 8.16132C8.44468 8.0468 8.84124 8.01487 9.23099 8.0677",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45215 10.5333C7.78316 10.3215 8.15564 10.1829 8.5446 10.1269C8.93356 10.0708 9.33001 10.0986 9.70736 10.2083",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57324 12.3677C7.9328 12.2089 8.32213 12.1286 8.71519 12.1324C9.10825 12.1362 9.49597 12.2239 9.85241 12.3896",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41602 14.199C7.79543 14.0964 8.19238 14.0762 8.58026 14.1396C8.96814 14.203 9.33797 14.3486 9.66497 14.5667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97949 15.9958C7.37018 15.951 7.76595 15.9908 8.13984 16.1127C8.51374 16.2346 8.85697 16.4356 9.14616 16.7021",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 17.724C6.65513 17.7373 7.04085 17.8366 7.39176 18.015C7.74268 18.1933 8.05029 18.4463 8.29297 18.7563",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6426 6C17.037 6.00066 17.4262 6.09016 17.7812 6.26183C18.1363 6.43351 18.4482 6.68296 18.6936 6.99167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 8.0677C16.2229 8.00968 16.6208 8.03912 16.9979 8.15389C17.3749 8.26865 17.7218 8.46587 18.0132 8.73124",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3574 10.2083C15.7341 10.093 16.1316 10.0621 16.5216 10.1179C16.9116 10.1737 17.2845 10.3149 17.6137 10.5313",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2139 12.3896C15.5688 12.2191 15.9568 12.1288 16.3505 12.125C16.7442 12.1212 17.1339 12.2041 17.492 12.3677",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4014 14.5667C15.7261 14.3437 16.096 14.1951 16.4848 14.1316C16.8735 14.068 17.2715 14.091 17.6503 14.199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9209 16.7021C16.2067 16.4308 16.5493 16.2266 16.924 16.1044C17.2986 15.9822 17.6958 15.9451 18.0865 15.9958",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 18.7563C17.0094 18.4422 17.3162 18.1863 17.6679 18.0075C18.0197 17.8288 18.4073 17.7318 18.8018 17.724",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRosterSport);
export default __webpack_public_path__ + "static/media/ico-rosterSport.3338b8b9.svg";
export { ForwardRef as ReactComponent };